module.exports = __webpack_public_path__ + "static/media/Plate.a3318b7b.svg";